export default __webpack_public_path__ + "static/media/454.691837d7.jpg";